require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-design-anthology-paul-conrad-working-in-the-grey.json") })
        }
      }, "path---journal-design-anthology-paul-conrad-working-in-the-grey");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-design-anthology-paul-conrad-working-in-the-grey!./.cache/json/journal-design-anthology-paul-conrad-working-in-the-grey.json
// module id = 476
// module chunks = 231608221292675